/**
 * URL base del API NestJS de Planillas/Cierres.
 * Override: REACT_APP_PLANILLAS_API o REACT_APP_API_URL
 */
export const API_BASE_URL = (
  process.env.REACT_APP_PLANILLAS_API ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:4001"
).replace(/\/$/, "");

export const PLANILLAS_API = API_BASE_URL;
